import { readable, writable } from "svelte/store";

export const dataStore = writable([])
   
